import Phaser from "phaser";
import { cst } from "../helpers/cst";
import buttonBehaviours from "../helpers/button-behaviours";
import GUI from "../view/gui.js";

export default class End extends Phaser.Scene {
  constructor() {
    super(cst.scenes.end);
  }

  preload() {}

  create(data) {
    this.score = data.score;

    this.add.image(
      this.cameras.main.width / 2,
      this.cameras.main.height / 2,
      "bg-main"
    );
    this.add
      .image(
        this.cameras.main.width / 2,
        this.cameras.main.height / 2,
        "box-end"
      )
      .setScale(0.9);

    this.add
      .text(
        this.cameras.main.width / 2,
        this.cameras.main.height / 2 - 230,
        "Your Score",
        cst.textstyles.end
      )
      .setOrigin(0.5);

    this.add
      .text(
        this.cameras.main.width / 2,
        this.cameras.main.height / 2,
        this.score,
        cst.textstyles.score
      )
      .setOrigin(0.5);

    this.btnMenu = this.add
      .image(
        this.cameras.main.width / 2 - 125,
        this.cameras.main.height / 2 + 240,
        "btn-menu"
      )
      .setInteractive({ useHandCursor: true })
      .on("pointerdown", () => {
        buttonBehaviours.pushOnClick(this, this.btnMenu, () => {
          this.scene.start(cst.scenes.menu);
        });
      })
      .setScale(1.5);

    this.btnPlayAgain = this.add
      .image(
        this.cameras.main.width / 2 + 125,
        this.cameras.main.height / 2 + 240,
        "btn-play-again"
      )
      .setInteractive({ useHandCursor: true })
      .on("pointerdown", () => {
        buttonBehaviours.pushOnClick(this, this.btnPlayAgain, () => {
          if (!this.scene.get(cst.scenes.gui))
            this.scene.add(cst.scenes.gui, GUI, false);

          setTimeout(() => {
            this.scene.start(cst.scenes.board);
          }, 500);
        });
      })
      .setScale(1.5);
  }

  upload() {}
}
